
/**
 * Internal dependencies
 */
import {
    INVOICES_RECEIVE,
    INVOICES_REQUEST,
    INVOICES_REQUEST_SUCCESS,
    INVOICES_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';

/**
 * [description]
 * 
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestInvoices = (page = 1, limit = 10) => (dispatch) => {
    dispatch({
        type: INVOICES_REQUEST
    });
    return cscom.invoice().list()
        .then(invoices => {
            dispatch({
                type: INVOICES_REQUEST_SUCCESS,
            });
            dispatch({
                type: INVOICES_RECEIVE,
                payload: {
                    items: invoices
                }
            });
            return invoices
        }).catch((error) => {
            dispatch({
                type: INVOICES_REQUEST_FAILURE,
                error,
            });
        });
}
